import axios from '@/store/config'
import dayjs from 'dayjs'
import auth from '@/auth'
import store from '@/store'
import { AUTH_STATUSES } from '@/config/constants'
import {axios as axios_new_api} from '@/store/config'

// Logga om man vill
const log = (false) ? () => {} : () => {}

/**
 * Lägger den på window så att den blir "statisk" och bara läggs till en gång
 */
if(!window.__pingIntervalFunction){
  window.__pingIntervalFunction = () => {

    if(store.getters.getPingInterval === null){
      log('pingInterval är null, bail');
      return;
    }

    if (dayjs.unix(store.getters.getPingTimestamp).diff(dayjs()) > store.getters.getPingInterval) {
      log('mindre än '+store.getters.getPingInterval+' sekunder sen senaste ping. Gör inget....');
    } else {
      log('mer än '+store.getters.getPingInterval+' sekunder sen senaste ping. Pingar!');
      return store.dispatch('ping')
    }
  }

  setInterval(window.__pingIntervalFunction, 1000)
}

export default {

  // state
  state : {
    pingTimestamp: null, // OK att den är null vid initiering. Då körs första pingen direkt.
    pingInterval: null,
    ssoPingTimestamp: dayjs(), // SSO behöver inte pinga så ofta som vanliga.
    pingData: {}
  },

  getters: {
    getPingTimestamp: state => state.pingTimestamp,
    getPingData: state => state.pingData,
    getPingInterval: state => state.pingInterval,
    getApiBaseUrl: state => axios_new_api.defaults.baseURL,

    /**
     * Kolla om det har gått mer än 10 minuter sedan senaste ssoPingen
     */
    isItTimeToAlsoPingSSO: state => {
      return () => {
        const ssoQueryString = store.getters.SSOQueryString;
        const invalidSsoQueryString = !ssoQueryString || ssoQueryString === 'null' || ssoQueryString === 'undefined';
        return invalidSsoQueryString || dayjs().diff(state.ssoPingTimestamp, 'minutes') >= 10
      }
    },

    ongoingSync: state => {
      return Object.keys(state.pingData).some(k => state.pingData[k] === true);
    }
  },

  actions: {
    setPingInterval({ commit, dispatch, getters }, interval){
      commit('setPingInterval', interval)
    },

    ping({ commit, dispatch, getters, state }){
      return new Promise((resolve, reject) => {
        commit('setPingTimestamp');

        return axios.get('applicants/me/ping')
          .then((response) => {
            //response.data.isSyncingOffers = state.fake;
            //response.data.isSyncingNotesOfInterest = state.fake;
            //  response.data.isSyncingContracts = pings++ < 3;
            commit('pingData', response.data);

            /**
             * Pingar SSO med. Men bara var tionde minut max
             */
            if(getters.isItTimeToAlsoPingSSO()){
              dispatch('loginSsoMe').then(() => {
                auth.refreshTokenCookie();
                resolve();
              })

              commit('setSSOPingTimestamp');
            } else {
              auth.refreshTokenCookie();
              resolve();
            }
          }).catch(err => {
            if (err && err.response && err.response.status == 401 && !window.location.pathname.match(/mina-sidor-exit-xpand/)) {
              dispatch('setAuthStatus', AUTH_STATUSES.INVALID)

              return resolve();
            }

            return reject(err)
          })
      })
    }
  },

  mutations:{
    pingData(state, data){
      state.pingData = data;
    },
    setPingInterval(state, interval){
      state.pingInterval = interval
    },
    setSSOPingTimestamp(state){
      state.ssoPingTimestamp = dayjs();
    },
    setPingTimestamp(state){
      state.pingTimestamp = dayjs();
    }
  }
}
